import { grey600 } from './chronasColors'

export const backIcon = {
  color: grey600,
}

export const drawer = {
  title: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  header: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
}

export const tooltip = {
  marginLeft: '40px',
  marginTop: '-37px'
}
